let host = '';

let env = process.env.NODE_ENV;
console.log(`***********************  运行环境： ${env} ************************`)
if (env == 'production' || env == 'prev') {
    host = 'http://eapi.my.ciwong.com'
} else {
    host = 'http://eapi.my.jiaofucloud.cn'
}

export const http = host
export let clientId = 100131
export let brandId = 570678343



// WEBPACK FOOTER //
// ./src/config.js